import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';
import { getCommentCount, getwemediaEAccountInfo } from '../../../../../../../services/api';
import { rel } from '../../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        joinNum: 0,
        count: 0,
        weMediaName: '',
    };

    async componentDidMount() {
        const { commentUrl, wemediaEAccountId } = this.props.content;

        try {
            const data = await getCommentCount(commentUrl);

            this.setState({
                joinNum: data.join_count,
                count: data.count,
            });
        } catch (e) {
            console.error(e);
        }

        if (wemediaEAccountId && wemediaEAccountId !== '') {
            try {
                const data = await getwemediaEAccountInfo(wemediaEAccountId);

                this.setState({
                    weMediaName: data.weMediaName ? data.weMediaName : '',
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        const { joinNum, count, weMediaName } = this.state;
        const { content } = this.props;
        const {
            title,
            dateTime,
            wemediaEAccountId,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            followUrl,
        } = content;

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        return (
            <div>
                <h1 className={styles.topic}>{title}</h1>
                <div className={styles.info}>
                    <p className={styles.time}>
                        <span className={styles.date}>{dateTime}</span>
                        <br />
                        <span style={{ verticalAlign: 'bottom' }}>来源：</span>
                        <span className={styles.publisher}>
                            {weMediaName === '' && !wemediaEAccountId ? (
                                <span className={styles.source}>
                                    {sourceUrl && sourceUrl !== '' ? (
                                        <a href={sourceUrl} target="_blank" rel={rel}>
                                            {source}
                                        </a>
                                    ) : (
                                        <span>{source}</span>
                                    )}
                                </span>
                            ) : (
                                <span className={styles.source}>
                                    <a href={`//feng.ifeng.com/author/${wemediaEAccountId}`} target="_blank" rel={rel}>
                                        {weMediaName}
                                    </a>
                                    <span className={styles.icon} />
                                </span>
                            )}
                        </span>
                    </p>
                    <div className={styles.share_box}>
                        <ContentShare shareInfo={shareInfo} />
                    </div>
                    <div className={styles.comment_box}>
                        <h5 className={styles.comment}>
                            <a className={styles.joinNum} href={followUrl} target="_blank" rel={rel}>
                                <span className={styles.num}>{joinNum}</span>
                                <span className={styles.text}>人参与</span>
                            </a>
                            <a className={styles.commentNum} href={followUrl} target="_blank" rel={rel}>
                                <span className={styles.num}>{count}</span>
                                <span className={styles.text}>评论</span>
                            </a>
                        </h5>
                    </div>
                </div>
                <div className={styles.devide} />
            </div>
        );
    }
}

export default errorBoundary(Caption);
